import { Box, CircularProgress } from "@mui/material";
import type { ReactNode } from "react";

export function LoadingWebpart(): React.JSX.Element {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
      <CircularProgress />
    </Box>
  );
}

interface LoadingWrapperProps {
  isLoading: boolean;
  children: ReactNode;
}

export function LoadingWrapper({ isLoading, children }: LoadingWrapperProps): React.JSX.Element {
  return isLoading ? <LoadingWebpart /> : <>{children}</>;
}
